// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStataxbtc } from "../../../icons/full/build/icon-stataxbtc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StataxbtcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStataxbtc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StataxbtcIcon.displayName = 'StataxbtcIcon';
}

export default StataxbtcIcon;